module.exports = __webpack_public_path__ + "img/DE01392.e3083af4.png";